module.exports = __webpack_public_path__ + "img/ic_wx_gzh.b4cb221d.png";